module.exports = __webpack_public_path__ + "img/one_banner.8f1a5a23.png";